enum HotspotStatus {
  ONLINE = 'online',
  OFFLINE = 'offline',
}

export default HotspotStatus;
